import React from 'react';
import AccountInfo from './AccountInfo';
import SubscriptionInfo from './SubscriptionInfo';

class MyAccountView extends React.Component {
  render() {
    return (
      <span>
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-2"></div>
        <div className="row">
          <div className="col-12 col-xl-8">
            <AccountInfo />
            <SubscriptionInfo />
          </div>
        </div>
      </span>
    );
  }
}

export default MyAccountView;
